import React, { useEffect, useState } from "react";
import back from "../../../assets/back.svg";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import InputField from "../../../components/form/inputField/inputField";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { AdminButton } from "../../../components/buttons/versionHistoryBtn";
import ErrorMsg from "../../../components/form/errorMsg";
import {
  permissionsRoleList,
  superUserRoleDetails,
  updateSuperUserRole,
} from "../../../redux/actions/superUserAction";
import { useDispatch } from "react-redux";
import ChangeSaved from "../../../components/popups/ChangeSaved";
import InputCapitalField from "../../../components/form/inputField/inputCapitalField";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import useReactRouterBreadcrumbs from "use-react-router-breadcrumbs";
import ErrorPopup from "../../../components/popups/ErrorPopup";

const SuperUserRoleEdit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [superUserRoleData, setSuperRoleUserData] = useState(null);
  const [permission, setPermission] = useState([]);
  const [edited, setEdited] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");

  useEffect(() => {
    setLoading(true);
    dispatch(
      superUserRoleDetails(params?.id, fetchDetailSuccess, fetchDetailError)
    );
    dispatch(permissionsRoleList(fetchPermissionSuccess, fetchPermissionError));
    // dispatch(vendorDivisionList(fetchDivisionSuccess, fetchDivisionError));
  }, []);

  const fetchDetailSuccess = (data) => {
    setLoading(false);
    setSuperRoleUserData(data.data.data);
    console.log("permissoin", data?.data?.data);
  };

  const fetchDetailError = (err) => {
    setLoading(false);
    console.log(err);
  };

  const fetchPermissionSuccess = (data) => {
    console.log("permissions", data);
    const updatedPerissions = data.map((item) => ({
      ...item,
      read: false,
      write: false,
    }));
    setPermission(updatedPerissions);
  };

  const fetchPermissionError = (err) => {
    console.log(err);
  };

  const updatedData = permission.map((item) => {
    const matchingItem = superUserRoleData?.vendorSuperUserPermissions?.find(
      (d) => d.permission_id == item.id
    );
    console.log(matchingItem, "data");
    if (matchingItem) {
      return {
        ...item,
        read: matchingItem.read,
        write: matchingItem.write,
      };
    }
    return item;
  });

  console.log(updatedData);

  const initialValues = {
    role_id: superUserRoleData?.id || "",
    role_name: superUserRoleData?.role_name || "",
    role_level: superUserRoleData?.role_level || "",
    permissions: updatedData || "",
  };

  console.log(initialValues);
  const validationSchema = Yup.object().shape({
    role_name: Yup.string().required("Required"),
    role_level: Yup.string().required("Required"),
    permissions: Yup.array().min(1, `Required`).required("Required"),
  });

  const resetFunc = (setFieldValue) => {
    setFieldValue("role_name", superUserRoleData?.role_name);
    setFieldValue("role_level", superUserRoleData?.role_level);
    setFieldValue("permissions", updatedData);
  };

  const onSubmit = (values) => {
    console.log(values);
    dispatch(updateSuperUserRole(values, onSuccess, onError));
  };

  const onSuccess = (data) => {
    console.log(data);
    setEdited(true);

    const timeOutFnc = () => {
      setEdited(false);
      navigate("/super-user/role");
    };

    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const modified_str = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(modified_str);
  };

  const handleCheckboxChange = (key, field, setFieldValue) => {
    return (e) => {
      const isChecked = e.target.checked;
      setFieldValue(`permissions.${key}.${field}`, isChecked);
      if (field == "write" && isChecked) {
        setFieldValue(`permissions.${key}.read`, true);
      } else if (field == "write" && !isChecked) {
        setFieldValue(`permissions.${key}.read`, false);
      }
    };
  };
  const routes = [
    { path: "/", breadcrumb: "Admin" },
    {
      path: "/super-user/role",
      breadcrumb: " / super users / role",
    },

    {
      path: "/super-user/role/edit/:id",
      breadcrumb: superUserRoleData?.role_id
        ? ` / ${superUserRoleData?.role_id} - edit`
        : " / edit",
    },
  ];

  const breadcrumbs = useReactRouterBreadcrumbs(routes, {
    disableDefaults: true,
  });

  return (
    <>
      <div className="products-page">
        <div className="products-main-div">
          <div className="mx-3">
            {breadcrumbs.map(({ match, breadcrumb }) => (
              <NavLink
                key={match.pathname}
                to={match.pathname}
                className="header-route-page fw_400 cursor_pointer"
              >
                <span className="fs_18">{breadcrumb}</span>
              </NavLink>
            ))}
          </div>
          <div className="products-main-list my-2 py-1">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              enableReinitialize={true}
              onSubmit={onSubmit}
            >
              {({ setFieldValue, values }) => (
                <Form className="">
                  <div className="search-container d-flex justify-content-between align-items-center">
                    <div
                      className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                      onClick={() => navigate(-1)}
                    >
                      <img src={back} alt="back_btn" />
                      <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                        BACK
                      </span>
                    </div>
                    <div className="d-flex justify-content-between m-1 mb-2">
                      <AdminButton
                        background="#E7E5FF"
                        width="100px"
                        type="button"
                        onClick={() => resetFunc(setFieldValue)}
                      >
                        RESET
                      </AdminButton>
                      <AdminButton
                        background="#2AD3E7"
                        color="white"
                        width="100px"
                        type="submit"
                      >
                        <span className="m-2">SAVE</span>
                      </AdminButton>
                    </div>
                  </div>
                  <div style={{ position: "relative" }}>
                    {loading == true ? (
                      <div className="list-spinner-container">
                        <LoadingSpinnerTable />
                      </div>
                    ) : (
                      <div className="scrolling">
                        <div className="form-width ms-4 ps-3 py-1">
                          <div className="my-4">
                            <label className=" Neutral_Color fs_14">
                              Role id
                            </label>
                            <p className="fs_14">
                              {superUserRoleData?.role_id}
                            </p>
                          </div>
                          <div className="my-1">
                            <InputCapitalField
                              setFieldValue={setFieldValue}
                              id={"role_name"}
                              label={"Role Name"}
                              type={"text"}
                              placeholder={"Enter role name"}
                              name={"role_name"}
                              value={values?.role_name}
                            />
                          </div>
                          <div className="my-1">
                            <InputField
                              id={"role_level"}
                              label={"Role Level"}
                              type={"text"}
                              placeholder={"Enter role level"}
                              name={"role_level"}
                              value={values?.role_level}
                            />
                          </div>
                          <div className="my-0">
                            <label className=" color_262c3d fs_14">
                              Permission
                            </label>
                          </div>
                          <div className="my-1 d-flex  label-container align-items-center justify-content-start ">
                            <div className="col-5">
                              <label className="color_b0b3c7 fs_14">
                                Models
                              </label>
                            </div>
                            <label className="color_b0b3c7 fs_14 ms-4 ps-2">
                              Read
                            </label>
                            <label className="color_b0b3c7 fs_14 ms-4 ps-2">
                              Write
                            </label>
                          </div>
                          {initialValues?.permissions.map((ele, id, index) => (
                            <div
                              key={ele.id}
                              className="d-flex my-1 label-container align-items-center justify-content-start"
                            >
                              <div className="col-6">
                                <label className="fs_14">{ele.label}</label>
                              </div>
                              <div>
                                <span className="fs_14 my-1">
                                  <Field
                                    className="superCheck"
                                    type="checkbox"
                                    name={`permissions.${id}.read`}
                                    disabled={values?.permissions[id]?.write}
                                    onChange={handleCheckboxChange(
                                      id,
                                      "read",
                                      setFieldValue
                                    )}
                                  />
                                </span>
                              </div>
                              <div className="ms-5">
                                <span className="fs_14 my-1">
                                  <Field
                                    className="superCheck"
                                    type="checkbox"
                                    name={`permissions.${id}.write`}
                                    onChange={handleCheckboxChange(
                                      id,
                                      "write",
                                      setFieldValue
                                    )}
                                  />
                                </span>
                              </div>
                            </div>
                          ))}
                          <ErrorMsg name={"permissions"} />
                        </div>
                      </div>
                    )}
                  </div>
                </Form>
              )}
            </Formik>
            <ChangeSaved
              show={edited}
              title={"Super User Edited Successfully"}
            />
            <ErrorPopup
              show={showErrorPopup}
              title={showErrorMsg}
              handleClose={closeErrorPopup}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SuperUserRoleEdit;
export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    color: "#464646",
    fontFamily: "Nunito sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "5px",
    width: "100%",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
};
